import { MIN_BACKGROUND_RADIUS_VW } from './constants';

export const parseBackgroundRadiusVw = (value?: string): number => {
  if (!value) {
    return MIN_BACKGROUND_RADIUS_VW;
  }

  const parsed = parseFloat(value);

  return Number.isFinite(parsed) ? parsed : MIN_BACKGROUND_RADIUS_VW;
};
